export default "__VITE_ASSET__JEysmab___"